module.exports = __webpack_public_path__ + "logo-transparent-center-small.f600ca9ba280de8af5ff.png";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/logo/logo-transparent-center-small.png
// module id = ../../../../../src/assets/images/logo/logo-transparent-center-small.png
// module chunks = styles